import { ProductSubCategoryDetailPage } from '@/features/product-sub-category/pages/ProductSubCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-sub-category/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubCategoryDetailPage,
})
